import { action } from '@storybook/addon-actions';
import { Meta, StoryObj } from '@storybook/react';

import { Button } from './Button';

const meta: Meta<typeof Button> = {
  title: 'parts/link button/Button',
  component: Button,
  args: {
    text: 'basic button',
    disabled: false,
    addClass: [],
    handleClick: action('click'),
  },
};

export default meta;

type Story = StoryObj<typeof Button>;

export const Basic: Story = {
  render: args => <Button {...args} />,
};
